function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-996.36)",
  fill: "none",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.381,
  cy: 1017.8,
  r: 0.52273,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32.835,
  cy: 1017.8,
  r: 0.52273,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: "1px"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.767 1015.2c3.1364-2.0908 6.2727 0 6.2727 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m36.494 1015.2c-3.1364-2.0908-6.2727 0-6.2727 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.176 1019.4s1.7369 2.9223 1.0455 4.1819c-0.5303 0.9659-3.1364 1.0454-3.1364 1.0454"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.904 1027.7c2.6369 2.264 7.5489 1.7669 10.455 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.04 1030.9h4.1818"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.004 1016.2s-1.6175-2.2462-2.9273-1.0455c-2.326 2.1326-1.3059 7.3046 1.0455 9.4092 1.2983 1.1621 1.8818 0 1.8818 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.45 1017.9s-1.06-1.2653-1.6364-0.9091c-1.0311 0.6372 0.09091 4.5455 0.09091 4.5455"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.489 1016.2s1.4357-2.2462 2.7455-1.0455c2.326 2.1326 1.3059 7.3046-1.0455 9.4092-1.2983 1.1621-1.8818 0-1.8818 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.861 1017.9s1.06-1.2654 1.6364-0.9091c1.0311 0.6372-0.09091 4.5455-0.09091 4.5455"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0,-996.36)",
  fill: "none",
  strokeWidth: "1px"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16.359 1013.4c-1.9091-6.3636 1.4545-7.2727 0.54546-8.1819-0.90909-0.909-0.90909-3.6362-0.90909-3.6362s4.7449 2.3129 6.3636 0.909c-0.90909-1.8182-1.3552-5.223 0-4.5454 2.7273 2.7272 10.909 2.7272 15.455 5.4545 3.4862 2.0918 4 10 2.1818 10.909"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.269 1035.2v17.273"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.359 1035.2v17.273"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.9958 1052.5s-0.5994-7.7969 2.7273-10.909c3.5406-3.3125 14.545-2.7273 14.545-2.7273"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.863 1052.5s0.5994-7.7968-2.7273-10.909c-3.5406-3.3125-14.545-2.7274-14.545-2.7274"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.269 1039.8c5.4545 5.4547 9.0909 0 9.0909 0"
})), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(46.607)",
  x: 52.846,
  y: 11.592,
  width: 2.6572,
  height: 2.6572,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "var(--primary-color, #000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27.476 51.04h0.56l1.4798 4.4h-3.52z",
  fill: "var(--primary-color, #000)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 21,42.54 14.1776,48.8582 19,56.04",
  strokeWidth: "1px"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.4 42.54 6.5412 6.3181-5.5412 7.1819",
  strokeWidth: "1px"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.676 23.04c0.17795 11.499-6.2727 16.727-12.545 16.727-7.3182 0-13.093-6.2871-12.545-16.727 0.41039-7.8181 3.1377-11.454 3.1377-11.454 6.2965 1.8552 15.455-0.9091 15.455-0.9091 2.7273 0.9091 6.3636 3.6363 6.4987 12.364z"
}));

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Face.f71d8bd2.svg";
export { ForwardRef as ReactComponent };